import { useEffect } from "react";
import { Spin, Typography } from "antd";

const { Text } = Typography;

/**
 * Login страница — НЕ показывает форму. Сразу редиректит на /api/v1/auth/login,
 * который уже редиректит на NC OIDC. Если пользователь залогинен в NC и
 * у клиента отключён consent — пройдёт без единого клика.
 */
export const LoginPage: React.FC = () => {
  useEffect(() => {
    // return_to берём из sessionStorage (если был сохранён до /login),
    // иначе корень → /dashboard через redirect index роута.
    const returnTo = sessionStorage.getItem("finance.return_to") || "/";
    sessionStorage.removeItem("finance.return_to");
    const url = `/api/v1/auth/login?return_to=${encodeURIComponent(returnTo)}`;
    // replace чтобы кнопка "Назад" не зацикливала
    window.location.replace(url);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f0f2f5",
        gap: 16,
      }}
    >
      <Spin size="large" />
      <Text type="secondary">Вход через Nextcloud…</Text>
    </div>
  );
};
